import {
  signOut,
  sendPasswordResetEmail,
  GoogleAuthProvider,
  signInWithPopup,
  OAuthProvider,
} from "firebase/auth";
import { Auth } from "../../utils/firebase/firebase.config";
import { APP_MESSAGE } from "../../config/Messages.config";

const provider = new GoogleAuthProvider();
const appleProvider = new OAuthProvider("apple.com");

// Add optional scopes (name/email)
appleProvider.addScope("email");
appleProvider.addScope("name");

// Function to get user-friendly error messages
const getAuthErrorMessage = (error) => {
  if (!error || !error.code) {
    return APP_MESSAGE.AUTH_ERRORS.DEFAULT_ERROR;
  }

  const errorCode = error.code;
  const { AUTH_ERRORS } = APP_MESSAGE;

  // Map Firebase error codes to user-friendly messages
  switch (errorCode) {
    case 'auth/popup-closed-by-user':
      return AUTH_ERRORS.POPUP_CLOSED_BY_USER;
    case 'auth/popup-blocked':
      return AUTH_ERRORS.POPUP_BLOCKED;
    case 'auth/network-request-failed':
      return AUTH_ERRORS.NETWORK_ERROR;
    case 'auth/too-many-requests':
      return AUTH_ERRORS.TOO_MANY_REQUESTS;
    case 'auth/invalid-credential':
    case 'auth/wrong-password':
      return AUTH_ERRORS.INVALID_CREDENTIALS;
    case 'auth/account-exists-with-different-credential':
      return AUTH_ERRORS.ACCOUNT_EXISTS_WITH_DIFFERENT_CREDENTIAL;
    case 'auth/email-already-in-use':
      return AUTH_ERRORS.EMAIL_ALREADY_IN_USE;
    case 'auth/weak-password':
      return AUTH_ERRORS.WEAK_PASSWORD;
    case 'auth/user-not-found':
      return AUTH_ERRORS.USER_NOT_FOUND;
    case 'auth/user-disabled':
      return AUTH_ERRORS.USER_DISABLED;
    case 'auth/operation-not-allowed':
      return AUTH_ERRORS.OPERATION_NOT_ALLOWED;
    case 'auth/invalid-email':
      return AUTH_ERRORS.INVALID_EMAIL;
    case 'auth/requires-recent-login':
      return AUTH_ERRORS.REQUIRES_RECENT_LOGIN;
    default:
      // For unknown errors, try to extract a meaningful message
      if (error.message && !error.message.includes('Firebase:')) {
        return error.message;
      }
      return AUTH_ERRORS.DEFAULT_ERROR;
  }
};

// Function to send firebase link of reset password
export const sendResetPasswordLinkToEmail = async (email) => {
  try {
    await sendPasswordResetEmail(Auth, email);
  } catch (error) {
    throw error;
  }
};

// Function to firebase logout
export const firebaseLogOut = async () => {
  try {
    await signOut(Auth);
    return true;
  } catch (error) {
    console.error("Error while signing out: ", error);
    throw error;
  }
};

// Function to handle user login via Google
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(Auth, provider);
    // result.user contains user info
    return { user: result.user, credential: result.credential };
  } catch (error) {
    // Return user-friendly error message
    const userFriendlyMessage = getAuthErrorMessage(error);
    return { 
      error: {
        ...error,
        userFriendlyMessage
      }
    };
  }
};

// Function to handle user login via Apple
export const signInWithApple = async () => {
  try {
    const result = await signInWithPopup(Auth, appleProvider);
    // result.user contains user info
    return { user: result.user, credential: result.credential };
  } catch (error) {
    // Return user-friendly error message
    const userFriendlyMessage = getAuthErrorMessage(error);
    return { 
      error: {
        ...error,
        userFriendlyMessage
      }
    };
  }
};